module.exports = __webpack_public_path__ + "static/media/light-plus-icon.690b24fb.svg";